import {
  ADDORUPDATEBUSINESSNATURE_SUCCESS,
  ADDORUPDATEBUSINESSNATURE_FAILED,
  RESET_ADDORUPDATEBUSINESSNATURE,
  LOADING_ADDORUPDATEBUSINESSNATURE,
  NETWORK_ERROR_ADDORUPDATEBUSINESSNATURE,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAddorUpdateBusinessNature = () => {
  return { type: RESET_ADDORUPDATEBUSINESSNATURE };
};

const addorUpdateBusinessNature =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDORUPDATEBUSINESSNATURE });
    await adminServices
      .post("addOrUpdateBusinessNature", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(addorUpdateBusinessNaturesuccess(res.data));
            break;
          default:
            dispatch(addorUpdateBusinessNatureFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_ADDORUPDATEBUSINESSNATURE,
          payload: err,
        });
      });
  };
function addorUpdateBusinessNaturesuccess(data) {
  return {
    type: ADDORUPDATEBUSINESSNATURE_SUCCESS,
    payload: data,
  };
}
function addorUpdateBusinessNatureFailed(data) {
  return {
    type: ADDORUPDATEBUSINESSNATURE_FAILED,
    payload: data,
  };
}

export { resetAddorUpdateBusinessNature, addorUpdateBusinessNature };
